"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _H = _interopRequireDefault(require("./H1.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var H1 = function H1(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_H["default"], {
    className: className
  }, children);
};
H1.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
H1.defaultProps = {
  className: ''
};
var _default = exports["default"] = H1;